var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65883 1.3085C4.05246 0.696177 4.94755 0.696177 5.34119 1.3085L8.00951 5.45924C8.43734 6.12475 7.9595 7 7.16834 7H1.83167C1.0405 7 0.56266 6.12475 0.990489 5.45924L3.65883 1.3085Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65883 14.6915C4.05246 15.3038 4.94755 15.3038 5.34119 14.6915L8.00951 10.5408C8.43734 9.87525 7.9595 9 7.16834 9H1.83167C1.0405 9 0.56266 9.87525 0.990489 10.5408L3.65883 14.6915Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderInactiveIcon);
export default __webpack_public_path__ + "static/media/order-inactive-icon.2faa4778725adbd55c316a03b657eda7.svg";
export { ForwardRef as ReactComponent };